var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"forget-password-wrapper"},[_c('div',{staticClass:"content"},[_c('VerifyOtpCode',{attrs:{"action":'login'}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }